import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import ImageComponentHead from '../../../../../../generic/imageComponents/ImageComponentHead'
import FancyButton from '../../../knisotLines/Components/FancyButton'
import CollectImage from '../../../../../../generic/assets/collect.png'
import { IMarketOrderNote } from '../../../../../../modules/API/Market/models/marketRequests'
import ProductCard from './ProductCard'
import NoteButton from './NoteButton'

const Card = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  width: 90%;
  height: 100%;
  overflow: hidden;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 1rem 0; */
`

const TextArea = styled.textarea`
  width: 100%;
  height: clamp(150px, 50%, 270px);
 
  padding: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  font-family: inherit;
  color: #2d3748;
  resize: vertical;
  transition: all 0.2s ease;
  direction: rtl;
  outline: none;

  &:focus {
    border-color: #297F76;
    box-shadow: 0 0 0 3px rgba(41, 127, 118, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f7fafc;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 1rem;
`

const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
  padding: 0.5rem 0;
  max-height: 400px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f7fafc;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
`

type Props = {
  note: IMarketOrderNote
  handleSave: (note: IMarketOrderNote) => void
  isLoading?: boolean
}

const OrderNoteModal: React.FC<Props> = ({
  note,
  handleSave,
  isLoading,
} : Props) => {
  const [noteValue, setNoteValue] = useState<IMarketOrderNote>(note)
  const [isOpenTextComponent, setIsOpenTextComponent] = useState<boolean>(false)
  
  const handleOpenTextComponent = () => {
    setIsOpenTextComponent(!isOpenTextComponent)
  }

  const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNoteValue(prev => ({
      ...prev,
      Note: e.target.value
    }))
  }, [])
  return (
    <Card>
      <Header>
        <ImageComponentHead
          small={noteValue.Products.length > 0}
          img={CollectImage} 
        />
      </Header>
      {
        noteValue.Products.length > 0 && (
          <ButtonWrapper>
            <p>לחץ כדי לערוך</p>
            <NoteButton onClick={handleOpenTextComponent} />
          </ButtonWrapper>
        )
      }
      {
        noteValue.Products.length > 0 && !isOpenTextComponent ? (
          <>

            <ProductsList>
              {noteValue.Products.map((product, index) => (
                <ProductCard 
                  key={`${product.desc}-${index}`}
                  product={product}
                />
              ))}
            </ProductsList>
          </>

        ) :
        <>
          <TextArea
            id="order-note"
            value={noteValue.Note}
            onChange={handleChange}
            placeholder="הוסף הערה להזמנה..."
            aria-label="Order note"
            tabIndex={0}
            disabled={isLoading}
          />

          <Footer>
            <FancyButton 
              isLoading={isLoading}
              onClick={() => handleSave(noteValue)} tabIndex={0}
            >
              שמור
            </FancyButton>
          </Footer>
        
        </>
      }
    </Card>
  )
}
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #297F76;
  width: 100%;
  gap: 0.5em;
  align-items: center;
`
export default OrderNoteModal
